// ar translations
export const AR_TRANSLATIONS: { [key: string]: string } = {


    "--DropoffLateReason": "-- سبب التسرب متأخر --",
    "--FundingSource--": "-- مصدر التمويل --",
    "--PickupLateReason": "-- سبب تأخر الاستلام --",
    "--Seats--": "-- مقاعد --",
    "--Select--": "-- يختار --",
    "--SelectAccountStatus": "-- اختر حالة الحساب --",
    "--SelectAssist--": "-- اختر مساعدة --",
    "--SelectBodyType": "-- اختر نوع الجسم --",
    "--SelectBroker--": "-- اختر الوسيط --",
    "--SelectCancelReasons": "-- حدد أسباب الإلغاء --",
    "--SelectCapacity--": "-- اختر السعة --",
    "--SelectCompetency--": "-- اختر الكفاءة --",
    "--SelectCorporateUser": "-- اختر مستخدم الشركة --",
    "--SelectDateFormat": "-- اختر تنسيق التاريخ --",
    "--SelectDay--": "-- اختر اليوم --",
    "--SelectDiagnosismedicalCond": "-- Select Diagnosis/Medical Condition --",
    "--SelectDoModifier": "-- اختر تعديل --",
    "--SelectDrivers--": "-- حدد برامج التشغيل --",
    "--SelectDrivers--2": "-- اختر برامج التشغيل --",
    "--SelectEmploymentType": "-- اختر نوع التوظيف --",
    "--SelectEquipment--": "-- اختر المعدات --",
    "--SelectFleet--": "-- اختر الأسطول --",
    "--SelectFs--": "-- اختر خ م --",
    "--SelectFuelType": "-- اختر نوع الوقود --",
    "--SelectGroup--": "-- اختر المجموعة --",
    "--SelectMapper--": "-- اختر مصمم الخرائط --",
    "--SelectMemberRole": "-- اختر دور العضو --",
    "--SelectMethod--": "-- اختر الطريقة --",
    "--SelectMonth--": "-- اختر الشهر --",
    "--SelectOperationsManager": "-- اختر مدير العمليات --",
    "--SelectPlatformportal--": "-- اختر النظام الأساسي/البوابة --",
    "--SelectPosition--": "-- اختر المنصب --",
    "--SelectProficiency--": "-- اختر الكفاءة --",
    "--SelectPuModifier": "- حدد معدل PU -",
    "--SelectReason--": "-- اختر السبب --",
    "--SelectRoleType": "-- اختر نوع الدور --",
    "--SelectServiceAreas": "-- تحديد منطقة (مناطق) الخدمة --",
    "--SelectShiftAlign": "-- حدد محاذاة Shift --",
    "--SelectSpacetype--": "-- اختر نوع المسافة --",
    "--SelectStateCode": "-- اختر رمز الولاية --",
    "--SelectStationManager": "-- اختر مدير المحطة --",
    "--SelectStatus--": "-- اختر الحالة --",
    "--SelectStatuss--": "-- اختر الحالة (الحالات) --",
    "--SelectTemplate--": "-- اختر القالب --",
    "--SelectTimeFormat": "-- اختر تنسيق الوقت --",
    "--SelectType--": "-- اختر النوع --",
    "--SelectVehicle--": "-- اختر المركبة --",
    "--ServiceArea--": "-- منطقة الخدمة --",
    "--SpaceType--": "-- نوع المساحة --",
    "--selectRequiredOdometer--": "--اختر عداد المسافات المطلوب--",
    "--selectStatus--": "--اختر الحالة--",
    "-selectFundingSource-": "-اختر مصدر التمويل-",
    "10min": "10 دقيقة",
    "15min": "15 دقيقة",
    "1HourViolation": "انتهاك لمدة ساعة واحدة",
    "30min": "30 دقيقة",
    "Amendments": "التعديلات",
    "Announcement": "إعلان",
    "Cities Zones": "مناطق المدن",
    "Companies": "الشركات",
    "Drivers": "السائقون",
    "Drivers Load": "حمولة السائقين",
    "Equipment Planning": "تخطيط المعدات",
    "Equipments": "المعدات",
    "Funding Sources": "مصادر التمويل",
    "Holidays": "العطلات",
    "Late Forecast": "توقع التأخير",
    "Late Reasons": "أسباب التأخير",
    "Level of Service": "مستوى الخدمة",
    "Mapper": "المخطط",
    "Members": "الأعضاء",
    "Miles For Bucks": "أميال مقابل المال",
    "New Trip": "رحلة جديدة",
    "Offered": "معروضة",
    "Payors": "الدافعون",
    "Profiling": "الملف الشخصي",
    "Quarters": "الأرباع",
    "Schedule": "الجدول",
    "Service Areas": "مناطق الخدمة",
    "Shift Override": "تجاوز الوردية",
    "Space Type Checklist": "قائمة نوع المساحة",
    "Space Types": "أنواع المساحة",
    "Staff": "الموظفون",
    "Standing Orders": "الطلبات الدائمة",
    "Templates": "القوالب",
    "Timesheet": "جدول الوقت",
    "Trip Sheet": "ورقة الرحلة",
    "Vehicles": "المركبات",
    "Violations": "المخالفات",
    "aaccountStatusIsRequired": "حالة الحساب مطلوبة",
    "accept": "يقبل",
    "accepted": "مقبول",
    "acceptedTrips": "رحلات مقبولة",
    "accidentAndIncidentTraining": "التدريب على الحوادث والحوادث",
    "accountStatus": "حالة الحساب",
    "accountStatusIsRequired": "حالة الحساب مطلوبة",
    "acknowledgeByDriver": "اعتراف من قبل السائق",
    "act": "الفعل",
    "action": "فعل",
    "actions": "الإجراءات",
    "actualShift": "الوردية الفعلية",
    "add": "+ أضف",
    "addAddon": "أضف الملحق",
    "addAmendment": "إضافة تعديل",
    "addAnnouncement": "إضافة إعلان",
    "addAppointmentType": "إضافة نوع الموعد",
    "addBeneficiary": "إضافة مستفيد",
    "addBreak": "أضف استراحة",
    "addBroker": "إضافة وسيط",
    "addCancelReason": "أضف سبب الإلغاء",
    "addChecklist": "إضافة قائمة مرجعية",
    "addCity": "أضف مدينة",
    "addCompany": "أضف شركة",
    "addDistribution": "إضافة التوزيع",
    "addDriver": "إضافة سائق",
    "addEquipment": "أضف المعدات",
    "addFundingSource": "أضف مصدر التمويل",
    "addHoliday": "أضف عطلة",
    "addLegButton": "+ مسار",
    "addLevelOfService": "إضافة مستوى الخدمة",
    "addMapper": "إضافة مصمم الخرائط",
    "addMember": "إضافة عضو",
    "addModifierCode": "إضافة رمز التعديل",
    "addPayor": "إضافة بايور",
    "addPrimaryDiagnose": "إضافة التشخيص الأساسي",
    "addQuarter": "أضف ربع",
    "addRate": "إضافة معدل",
    "addReason": "أضف سببًا",
    "addServiceArea": "إضافة منطقة الخدمة",
    "addShift": "إضافة التحول",
    "addShiftOverride": "إضافة تجاوز التحول",
    "addSpaceType": "أضف نوع المساحة",
    "addStaff": "أضف فريق العمل",
    "addTemplate": "إضافة قالب",
    "addTips": "أضف نصائح",
    "addTripHeader": "إضافة",
    "addVehicle": "أضف مركبة",
    "addYourComment": "أضف تعليقك",
    "addYourComment2": "أضف تعليقك...",
    "addZone": "أضف منطقة",
    "additionalInformation": "معلومات إضافية",
    "additionalNote": "ملاحظة إضافية",
    "addonButton": "+ خدمة إضافية",
    "addonItemLabel": "العنصر",
    "addonItemRequired": "العنصر مطلوب",
    "addonServicesHeader": "خدمات إضافية",
    "address": "عنوان:",
    "addressLabel": "العنوان",
    "addressName": "اسم العنوان",
    "addressNameIsRequired": "اسم العنوان مطلوب",
    "addressRequired": "العنوان مطلوب",
    "addressValidationAlert": "تنبيه التحقق من صحة العنوان",
    "addupdateSignature": "إضافة/تحديث التوقيع",
    "adjustTrip": "ضبط الرحلة",
    "adjustment": "تعديل",
    "adlAmbulanceDriversLicense": "ADL (رخصة قيادة سيارات الإسعاف)",
    "adlImageIsRequired": "صورة ADL مطلوبة",
    "admin": "مسؤل",
    "agent": "عامل",
    "alarming": "مثيرة للقلق",
    "alarmingTrips": "رحلات مقلقة",
    "alcReminder": "تذكير ALC",
    "alcoholScreeningRecentScreen": "فحص الكحول (الفحص الأخير)",
    "algorithm": "خوارزمية",
    "all": "الجميع",
    "allDrivers": "جميع السائقين",
    "allMessages": "جميع الرسائل",
    "allNotifications": "جميع الإخطارات",
    "allowAttendee": "السماح للحاضرين",
    "allowAuthorizationNumberFor": "السماح برقم التفويض لـ One Care",
    "allowPlacement": "السماح بالوضع",
    "allowCamera": "السماح بالكاميرا",
    "allowCapacityViolation": "السماح بانتهاك السعة",
    "allowCapacityViolations": "السماح بانتهاك (انتهاكات) السعة",
    "allowIncentive": "السماح بالحافز",
    "allowIpcr": "السماح بـ IPCR",
    "allowAuditLogs": "السماح بسجلات التدقيق",
    "allowCoverage": "السماح بالتغطية",
    "auditlogs": "سجلات التدقيق",
    "allowMulti-factorAuthenticat": "السماح بالمصادقة متعددة العوامل",
    "allowNearBy": "السماح بالقرب",
    "allowOnboardViolations": "السماح بالانتهاكات على متن الطائرة",
    "allowPossibility": "السماح بالاحتمال",
    "allowSms": "السماح بالرسائل القصيرة",
    "allowTimesheet": "السماح بالجدول الزمني",
    "allowVoiceAssistance": "السماح بالمساعدة الصوتية",
    "ambulance": "سيارة إسعاف",
    "ambulette": "أمبولة",
    "amendment": "تعديل",
    "amountIsRequired": "المبلغ مطلوب",
    "announcements": "إعلانات",
    "api": "واجهة برمجة التطبيقات",
    "appealed": "استأنف",
    "appky": "ابكي",
    "applyIncentive": "تطبيق الحافز",
    "appointmentDirectionInside": "داخل المركز",
    "appointmentDirectionLabel": "اتجاه الموعد",
    "appointmentDirectionOutside": "خارج المركز",
    "appointmentTime": "وقت التعيين",
    "appointmentTimeIsRequired": "وقت التعيين مطلوب",
    "appointmentTypeLabel": "نوع الموعد",
    "appointmentTypeRequired": "نوع الموعد مطلوب",
    "appointmentTypefileIsRequire": "مطلوب نوع الموعد (ملف).",
    "appointmentTypetpIsRequired": "نوع الموعد (TP) مطلوب",
    "approachingAlert": "تنبيه الاقتراب",
    "approachingTrips": "رحلات قادمة",
    "approve": "يعتمد",
    "approved": "موافقة",
    "aptOrSuiteIs": "مطلوب APT أو Suite",
    "aptOrSuiteLabel": "شقة/جناح",
    "aptOrSuiteRequired": "شقة/جناح مطلوب",
    "aptsuiteroom": "شقة/جناح/غرفة",
    "arabicLanguageLabel": "العربية",
    "archive": "أرشيف",
    "archived": "مؤرشف",
    "archivedTrips": "الرحلات المؤرشفة",
    "areYouSureYou": "هل أنت متأكد أنك تريد نقل هذه الرحلة إلى وقت جديد؟",
    "areYouSureYou2": "هل أنت متأكد أنك تريد الإلغاء؟",
    "areYouSureYou3": "هل أنت متأكد أنك تريد تحديث عداد المسافات؟",
    "areYouSureYou4": "هل أنت متأكد أنك تريد إنشاء رحلة من الأمر الدائم للوالدين في هذا التاريخ المحدد؟",
    "areYouSureYou5": "هل أنت متأكد أنك تريد مسح كافة بيانات الرحلات من النظام؟ سيتعين عليك إعادة استيراد البيانات مرة أخرى لتعيين أي رحلات للسائق لأن هذا إجراء دائم؟",
    "arn": "آرن",
    "arrears": "المتأخرات",
    "arrearsLabel": "تسمية المتأخرات",
    "arrived": "وصل",
    "assign": "تعيين",
    "assignTrip": "تعيين رحلة",
    "assignMultipleTrips": "تعيين رحلات متعددة",
    "assignVehicle": "تعيين مركبة",
    "assignedTrips": "الرحلات المعينة",
    "assist": "يساعد",
    "assistShiftAlign": "مساعدة التحول محاذاة",
    "assistShiftAlignIs": "مطلوب مساعدة التحول محاذاة",
    "assistShiftDayWise": "مساعدة التحول (اليوم الحكيم)",
    "assistShiftEnd": "مساعدة نهاية التحول",
    "assistShiftEndIs": "مطلوب مساعدة نهاية التحول",
    "assistShiftStart": "مساعدة التحول في البداية",
    "assistShiftStartIs": "مطلوب مساعدة التحول البداية",
    "assistsLabel": "المساعدات",
    "associateImage": "الصورة المرتبطة",
    "atLeastOneAssist": "مطلوب تحول مساعدة واحد على الأقل",
    "atleastOneDayShift": "مطلوب وردية يوم واحد على الأقل",
    "atleastOneDriverIs": "مطلوب سائق واحد على الأقل",
    "attachPdfButton": "إرفاق ملف PDF",
    "attchedPdf": "مرفق قوات الدفاع الشعبي",
    "authNumberLabel": "رقم التفويض",
    "authorizationNumberIsRequire": "رقم التفويض مطلوب",
    "authorizer": "المأذون",
    "autoAssignWillCall": "سيتم الاتصال بالتعيين التلقائي",
    "autoGenerate": "إنشاء تلقائي",
    "autoRefresh": "التحديث التلقائي",
    "autoTimeStamp": "الطابع الزمني التلقائي",
    "autoTimestamp": "الطابع الزمني التلقائي",
    "autoZoom": "تكبير تلقائي",
    "available": "متاح",
    "avatar": "الصورة الرمزية",
    "backToLogin": "العودة إلى تسجيل الدخول",
    "background": "خلفية",
    "badPhonenumber": "رقم الهاتف غير صالح",
    "banked": "مصرفي",
    "baseFare": "الأجرة الأساسية",
    "baseFareCode": "رمز الأجرة الأساسية",
    "baseFareCodeIs": "رمز السعر الأساسي مطلوب",
    "baseFareFor": "الأجرة الأساسية لـ",
    "baseFareForIs": "الأجرة الأساسية مطلوبة",
    "baseFareIsRequired": "الأجرة الأساسية مطلوبة",
    "batch": "حزمة",
    "bedBugProtocol": "بروتوكول بق الفراش",
    "bedLengthIsRequired": "طول السرير مطلوب",
    "beginAt": "تبدأ عند:",
    "billTo": "مشروع قانون ل *",
    "billerNote": "ملاحظة بيلر",
    "billerNotes": "ملاحظات الفاتورة",
    "billing": "الفواتير",
    "bloodbornePathogenTrainingEx": "التدريب على مسببات الأمراض المنقولة بالدم (EXP)",
    "bloodbornePathogens": "مسببات الأمراض المنقولة بالدم",
    "bodyType": "نوع الجسم",
    "bodyTypeIsRequired": "نوع الجسم مطلوب",
    "both": "كلاهما",
    "break": "استراحة",
    "breakCushion": "وسادة الاستراحة:",
    "breakFinished": "استراحة (منتهية)",
    "breakScheduled": "استراحة (مجدولة)",
    "breaks": "الاستراحات",
    "broker-img": "وسيط img",
    "brokerConfiguration": "تكوين الوسيط",
    "brokerId": "معرف الوسيط",
    "brokerIsRequired": "مطلوب وسيط",
    "bsr": "بي إس آر",
    "bsr2": "بي إس آر:",
    "bulkConfirmation": "تأكيد بالجملة",
    "businessNumber": "رقم العمل",
    "businessNumberIsRequired": "رقم العمل مطلوب",
    "businessReport": "تقرير الأعمال",
    "businessReports": "تقارير الأعمال",
    "busy": "مشغول",
    "bySavingTheInformation": "من خلال حفظ المعلومات في هذا النموذج، فإنك تشهد، كممثل معتمد للمنظمة، أن المعلومات تعكس بدقة عمليات النقل التي أكملتها. أنت تقر بموجب هذا بأن هذه المعلومات صحيحة ودقيقة وكاملة على حد علمك وأنت تدرك أن أي تزوير أو إغفال أو إخفاء لحقيقة مادية قد يعرضك و/أو المنظمة إلى مسؤولية تعاقدية أو إدارية أو مدنية أو جنائية. أنت تدرك أيضًا أنه يجب الاحتفاظ بجميع الوثائق الخاصة بعمليات النقل هذه وفقًا لسياسات صيانة السجلات الخاصة بوسطاء التأمين المعنيين والشركات التابعة لهم.",
    "caTimesheet": "الجدول الزمني CA",
    "calculateButton": "احسب",
    "calculateLocalMiles": "حساب الأميال المحلية",
    "call": "يتصل",
    "callMemberToVerify": "اتصل بالعضو للتحقق من الإلغاء",
    "cancel": "يلغي",
    "cancelCharges": "إلغاء الرسوم",
    "cancelChargesIsRequired": "مطلوب إلغاء الرسوم",
    "cancelReason": "إلغاء السبب",
    "cancelReasons": "إلغاء الأسباب",
    "cancelReasonsIsRequired": "أسباب الإلغاء مطلوبة",
    "cancelTrip": "إلغاء الرحلة",
    "canceled": "ملغى",
    "cancellationNotes": "ملاحظات الإلغاء",
    "cancelled": "تم الإلغاء",
    "cancelledAt": "تم الإلغاء عند:",
    "cancelledFee": "الرسوم الملغاة *",
    "cancelledTripsSection": "قسم الرحلات الملغاة",
    "capacities": "القدرات",
    "capacity": "سعة",
    "capacityIsRequired": "القدرة مطلوبة",
    "careGiverInformation": "معلومات مقدم الرعاية",
    "caregiverDetailsAreRequired": "تفاصيل مقدم الرعاية مطلوبة",
    "centeneAttestationIss": "Centene Attestation (ISS)",
    "certificateOfCompletionOnlok": "شهادة الإنجاز (ONLOK)",
    "certificationIsRequired": "الشهادة مطلوبة",
    "certifiedMechanicVerificatio": "التحقق الميكانيكي المعتمد",
    "cf": "التليف الكيسي:",
    "change": "يتغير",
    "changePassword": "تغيير كلمة المرور",
    "checkin": "تحقق في",
    "checklist": "قائمة التحقق",
    "checklistIsRequired": "قائمة المراجعة مطلوبة",
    "checklistNameIsRequired": "اسم قائمة التحقق مطلوب",
    "checkout": "الدفع",
    "chineseLanguageLabel": "الصينية",
    "city": "مدينة",
    "cityIsRequired": "المدينة مطلوبة",
    "citystate": "المدينة/الولاية",
    "claim": "Claim",
    "claim2": "+ المطالبة",
    "claimIsRequired": "المطالبة مطلوبة",
    "claims": "المطالبات",
    "clear": "واضح",
    "clearVehicle": "مركبة واضحة",
    "clientIdLabel": "معرف العميل / معرف العضو / MA# / AHCCCS#",
    "clientIdRequired": "معرف العميل / معرف العضو / MA# / AHCCCS# مطلوب",
    "clone": "استنساخ",
    "close": "يغلق",
    "closePanel": "إغلاق اللوحة",
    "closeSidebar": "إغلاق الشريط الجانبي",
    "closer": "أقرب",
    "cms1500": "سي ام اس 1500",
    "code": "شفرة",
    "codeIsRequired": "الكود مطلوب",
    "color": "لون",
    "colorIsRequired": "اللون مطلوب",
    "comment": "تعليق",
    "commentIsRequired": "التعليق مطلوب",
    "comments": "تعليقات",
    "companiesStats": "إحصائيات الشركات",
    "company-img": "شركة img",
    "companyAlias": "الاسم المستعار للشركة *",
    "companyBillingName": "اسم فاتورة الشركة",
    "companyFaxNumber": "رقم فاكس الشركة",
    "companyImage": "صورة الشركة",
    "companyImageIsRequired": "صورة الشركة مطلوبة",
    "companyInTake": "الشركة المستحوذة (%)",
    "companyInTakeIs": "مطلوب شركة In Take",
    "companyMobileNumber": "رقم جوال الشركة",
    "companyMobileNumberIs": "مطلوب رقم الجوال للشركة",
    "companyName": "اسم الشركة",
    "companyNameIsRequired": "اسم الشركة مطلوب",
    "companyNotes": "ملاحظات الشركة",
    "companyPhoto": "صورة الشركة",
    "competency": "الكفاءة",
    "competencyIsRequired": "الكفاءة مطلوبة",
    "completed": "مكتمل",
    "completedFee": "الرسوم المكتملة *",
    "completedTimeIsRequired": "الوقت المكتمل مطلوب",
    "compliancePlanTrainingFraud": "التدريب على خطة الامتثال (الاحتيال والهدر وإساءة الاستخدام) (قواعد السلوك)",
    "configurations": "التكوينات",
    "confirm": "يتأكد",
    "confirmNewPassword": "تأكيد كلمة المرور الجديدة",
    "confirmPassword": "تأكيد كلمة المرور",
    "confirmPasswordDidtMatch": "تأكيد كلمة المرور غير متطابقة",
    "confirmPasswordIsRequired": "تأكيد كلمة المرور مطلوب",
    "confirmationReport": "تقرير التأكيد",
    "confirmationText": "نص التأكيد",
    "confirmedLabel": "مؤكد",
    "contactNumber": "رقم الاتصال",
    "contactNumberIsRequired": "رقم الاتصال مطلوب",
    "contractSent": "تم إرسال العقد",
    "corporate": "شركة كبرى",
    "corporateOdometerRequired": "مطلوب عداد المسافات للشركات",
    "corporatePrivatePay": "الشركات / الدفع الخاص",
    "costCenter": "مركز التكلفة",
    "costCenterIsRequired": "مركز التكلفة مطلوب",
    "coverImage": "صورة الغلاف",
    "covid": "مرض فيروس كورونا",
    "covid-19Vaccine": "لقاح كوفيد-19",
    "covid-19VaccineDeclined": "تم رفض لقاح كوفيد-19",
    "cprFirstAidCertification": "تاريخ بدء شهادة الإنعاش القلبي الرئوي / الإسعافات الأولية (EXP)",
    "cprFirstAidCertification2": "تاريخ انتهاء صلاحية شهادة الإنعاش القلبي الرئوي/الإسعافات الأولية (EXP)",
    "createBucket": "إنشاء دلو",
    "createButton": "إنشاء",
    "createSchedule": "إنشاء الجدول الزمني",
    "createTrip": "إنشاء رحلة",
    "createTripsManually": "إنشاء الرحلات يدويًا",
    "created": "مخلوق",
    "createdTimeIsRequired": "مطلوب وقت الإنشاء",
    "credentialInformation": "معلومات الاعتماد",
    "credentialing": "الاعتماد",
    "credentials": "أوراق اعتماد",
    "criminalBackgroundCheck": "فحص الخلفية الجنائية",
    "criminalRecordAlcoholOr": "السجل الجنائي (تعاطي الكحول أو المخدرات)",
    "ctc": "لجنة مكافحة الإرهاب",
    "ctcBot": "سي تي سي بوت",
    "ctcInvoice": "فاتورة سي تي سي",
    "ctcMarketplace": "سوق سي تي سي",
    "ctcTrips": "رحلات CTC",
    "currentMeter": "متر الحالي",
    "currentMileageIsRequired": "الأميال الحالية مطلوبة",
    "currentPassword": "كلمة المرور الحالية",
    "currentPasswordIsRequired": "كلمة المرور الحالية مطلوبة",
    "custom": "مخصص",
    "daily": "يوميًا",
    "dashboard": "لوحة التحكم",
    "date": "تاريخ",
    "dateFormat": "تنسيق التاريخ",
    "dateFormatIsRequired": "تنسيق التاريخ مطلوب",
    "dateIsRequired": "التاريخ مطلوب",
    "dateOfInspection": "تاريخ التفتيش",
    "dateOfInspectionIs": "تاريخ الفحص مطلوب",
    "dateOfService": "تاريخ الخدمة",
    "dateRange": "النطاق الزمني *",
    "dayRequired": "اليوم مطلوب",
    "days": "أيام",
    "days2": "أيام)",
    "daysIsRequired": "اليوم (الأيام) مطلوب",
    "ddmmyyyy": "يوم/شهر/سنة",
    "deadMiles": "مايلز الميت",
    "deadMilesRateIs": "معدل الأميال الميتة مطلوب",
    "deadheadTimeToPickup": "وقت الفراغ (إلى الاستلام)",
    "decline": "انخفاض",
    "defensiveDrivingCourse": "دورة القيادة الدفاعية",
    "delete": "يمسح",
    "deleteAll": "حذف الكل",
    "demo": "تجريبي",
    "description": "وصف",
    "descriptionIsRequired": "الوصف مطلوب",
    "detail": "التفاصيل",
    "details": "تفاصيل",
    "diagnosismedicalCondition": "التشخيص/الحالة الطبية",
    "diagnosismedicalConditionIsR": "Diagnosis/Medical Condition is required",
    "dimensions": "أبعاد",
    "discount": "تخفيض",
    "discountLabel": "تسمية الخصم",
    "dispatchMonthDay": "شهر الإرسال اليوم *",
    "dispatcher": "المرسل",
    "dispatcherNotesLabel": "ملاحظات المرسل",
    "display": "عرض",
    "displayMode": "وضع العرض",
    "displayNameLabel": "الاسم المعروض",
    "displayNameRequired": "الاسم المعروض مطلوب",
    "displaySection": "قسم العرض",
    "do": "توصيل",
    "doModifier": "هل المعدل",
    "doModifierIsRequired": "مطلوب تعديل DO",
    "doa": "عنوان التوصيل",
    "dobLabel": "تاريخ الميلاد",
    "dobRequired": "تاريخ الميلاد مطلوب",
    "done": "منتهي",
    "dos": "دوس:",
    "dot": "نقطة",
    "dotPhysicalExamAnnual": "الفحص البدني DOT (السنوي أو عند الطلب)",
    "downBaseAddress": "العنوان الأساسي السفلي",
    "download": "تحميل",
    "downloadCsv": "قم بتنزيل ملف CSV",
    "downloadPdf": "تحميل قوات الدفاع الشعبي",
    "downloadPdfReport": "تنزيل التقرير بصيغة PDF",
    "downloadReport": "تنزيل التقرير",
    "drawRoute": "رسم الطريق",
    "driveDistance": "مسافة القيادة",
    "driver": "سائق",
    "driver-score-chartsWorks": "تعمل مخططات نقاط السائق!",
    "driver2": "(سائق)",
    "driverAddress": "عنوان السائق",
    "driverAddressIsRequired": "عنوان السائق مطلوب",
    "driverAlerts": "تنبيهات السائق",
    "driverBreak": "استراحة السائق",
    "driverBreakdown": "انهيار السائق",
    "driverImage": "صورة السائق",
    "driverInTake": "سائق في اتخاذ (٪)",
    "driverInTakeIs": "مطلوب سائق في اتخاذ",
    "driverInformation": "معلومات السائق",
    "driverIsGettingLate": "السائق يتأخر",
    "driverIsIdle": "السائق خامل (لا رحلات)",
    "driverIsLate": "السائق متأخر",
    "driverIsOverloaded": "السائق محمل بشكل زائد (>12 رحلة)",
    "driverLoad": "تحميل السائق",
    "driverName": "اسم السائق",
    "driverNotesLabel": "ملاحظات السائق",
    "driverOdometer": "عداد المسافات للسائق",
    "driverProfile": "ملف تعريف السائق",
    "driverRequired": "السائق مطلوب",
    "driverRoadTrainingEvidence": "تدريب السائقين على الطريق (الأدلة)",
    "driverSched": "جدول السائق",
    "driverShift": "تحول السائق",
    "driverShiftDayWise": "تبديل السائق (اليوم)",
    "driverVerificationAlcohol": "التحقق من السائق (الكحول)",
    "driverVerificationDrug": "التحقق من السائق (المخدرات)",
    "driverdisplayname": "driver.displayName",
    "driversDrugTest": "اختبار المخدرات للسائق",
    "drivingRecordMeetsRequiremen": "سجل القيادة (يلبي المتطلبات)",
    "drop": "يسقط",
    "dropoffAddress": "عنوان التسليم",
    "dropoffAddressIsRequired": "عنوان التسليم مطلوب",
    "dropoffEarly": "النزول المبكر:",
    "dropoffHeader": "نقطة التوصيل",
    "dropoffLate": "التسرب متأخر:",
    "dropoffLateReason": "سبب النزول متأخر:",
    "dropoffLateReason2": "سبب النزول متأخر",
    "dropoffWise": "إسقاط الحكمة",
    "dryRun": "تشغيل جاف",
    "dryRunCode": "كود التشغيل الجاف",
    "dryRunCodeIs": "مطلوب رمز التشغيل الجاف",
    "dsr": "دسر:",
    "dt": "د.ت",
    "dt2": "DT:",
    "dueDay": "يوم الاستحقاق *",
    "duplicate": "ينسخ",
    "durationIsRequired": "المدة مطلوبة.",
    "dvCompetencyAssessmentIss": "تقييم كفاءة العنف المنزلي (ISS)",
    "dvRequired": "مطلوب العنف المنزلي",
    "earlyActionActualVsScheduled": "إجراء مبكر (الفعلي مقابل المجدول)",
    "earlyEta": "وقت مبكر لوقت الوصول المتوقع",
    "editNotes": "تحرير الملاحظات",
    "editProfile": "تحرير الملف الشخصي",
    "editShift": "تعديل التحول",
    "editTripHeader": "تعديل",
    "elderAbuseTraining": "التدريب على إساءة معاملة المسنين",
    "eligibility": "الأهلية",
    "eligibilityStatusIsRequired": "حالة الأهلية مطلوبة",
    "eligible": "صالح",
    "email": "بريد إلكتروني:",
    "emailAddress": "عنوان البريد الإلكتروني",
    "emailAddressIsRequired": "عنوان البريد الإلكتروني مطلوب",
    "emailConfiguration": "تكوين البريد الإلكتروني",
    "emailIsNotValid": "البريد الإلكتروني غير صالح",
    "emailLabel": "البريد الإلكتروني",
    "emailRequired": "البريد الإلكتروني مطلوب",
    "emergencyAndEvacuationTraini": "التدريب على حالات الطوارئ والإخلاء",
    "employeeId": "معرف الموظف",
    "employeeIdIsRequired": "معرف الموظف مطلوب",
    "employerNameIsRequired": "اسم صاحب العمل مطلوب",
    "employmentType": "نوع التوظيف",
    "employmentTypeIsRequired": "نوع التوظيف مطلوب",
    "emtDriver": "سائق إي إم تي",
    "emtLicense": "ترخيص EMT",
    "emtLicenseImageIs": "مطلوب صورة ترخيص EMT",
    "endDateLabel": "تاريخ الانتهاء",
    "endDateRequired": "تاريخ الانتهاء مطلوب",
    "endOfShift": "نهاية التحول",
    "endTime": "وقت النهاية",
    "endTimeIsRequired": "وقت الانتهاء مطلوب",
    "ended": "(انتهى)",
    "endedAt": "انتهت عند:",
    "englishLanguageLabel": "الإنجليزية",
    "ensureThereAreNo": "⚠️ التأكد من عدم وجود فراغات حول القولون. مطلوب 3 أحرف على الأقل لبدء البحث.",
    "enterTitle": "أدخل العنوان",
    "enterYourEmail": "أدخل بريدك الإلكتروني",
    "enterYourEmailAnd": "أدخل بريدك الإلكتروني وحدد الدور لتلقي رابط إعادة التعيين",
    "enterYourNewPassword": "أدخل كلمة المرور الجديدة أدناه",
    "equipmentsAreRequired": "المعدات مطلوبة",
    "esf": "إس إف:",
    "estimatedFareLabel": "الأجرة المقدرة",
    "estimatedFares": "الأسعار المقدرة",
    "estimatedPickupTimeLabel": "التقاط تقديري:",
    "every": "كل",
    "exiting": "مغادرة",
    "expandOnHover": "قم بالتوسيع عند التمرير",
    "expectedAppointmentTimeLabel": "وقت الموعد المتوقع",
    "expectedAppointmentTimeMinError": "لا يمكن أن يكون وقت الموعد المتوقع أسبق من وقت الالتقاط (التاريخ والوقت).",
    "expectedAppointmentTimeRequired": "وقت الموعد المتوقع مطلوب",
    "expenses": "نفقات",
    "expirationDate": "تاريخ انتهاء الصلاحية",
    "expirationDateIsRequired": "تاريخ انتهاء الصلاحية مطلوب",
    "expired": "منتهي الصلاحية",
    "expiredTrips": "رحلات منتهية",
    "expiredTripsRoutes": "مسارات الرحلات المنتهية",
    "expiryDate": "تاريخ انتهاء الصلاحية",
    "expiryDateIsRequired": "تاريخ انتهاء الصلاحية مطلوب",
    "exportCsv": "تصدير CSV",
    "extensiondispatcherNumber": "رقم الملحق/المرسل",
    "extensiondispatcherNumberIsR": "مطلوب رقم الملحق/المرسل",
    "exteriorInformation": "المعلومات الخارجية",
    "fare": "أجرة",
    "fareInformation": "معلومات الأجرة",
    "faxNumber": "رقم الفاكس",
    "feedback": "تعليق",
    "feet": "(قدم)",
    "fetch": "أحضر",
    "fetchEta": "جلب الوقت المتوقع للوصول",
    "fetchTime": "وقت الجلب",
    "file": "(ملف)",
    "fileIsRequired": "الملف مطلوب",
    "fileName": "اسم الملف",
    "filter": "فلتر",
    "fingerPrintLiveScan": "بصمة الإصبع المسح المباشر",
    "finished": "انتهى",
    "finishedAndCancelled": "انتهى وألغى",
    "finishedAt": "انتهى في:",
    "finishedCompleted": "منتهٍ / مكتمل",
    "finishedTimeIsRequired": "مطلوب وقت الانتهاء",
    "finishedTrips": "رحلات منتهية",
    "firstName": "الاسم الأول",
    "firstNameIsRequired": "الاسم الأول مطلوب",
    "firstNameMustBe": "يجب أن يتكون الاسم الأول من 3 أحرف على الأقل.",
    "fleet": "الأسطول",
    "fleetInformation": "معلومات الأسطول",
    "fleetIsRequired": "مطلوب الأسطول",
    "floorLabel": "الطابق",
    "floorRequired": "الطابق مطلوب",
    "florida": "فلوريدا",
    "flu": "الإنفلونزا",
    "fluVaccine": "لقاح الانفلونزا",
    "fluVaccineDeclined": "رفض لقاح الانفلونزا",
    "focalPerson": "الشخص المحوري",
    "focalPersonInformation": "معلومات الشخص المحوري",
    "for": "ل",
    "force": "قوة",
    "forcedAcceptTrips": "القبول القسري للرحلات",
    "forgotPassword": "هل نسيت كلمة السر",
    "forgotPassword2": "هل نسيت كلمة السر؟",
    "form837": "النموذج 837",
    "form837V2": "نموذج 837 v2",
    "freeQuota": "حصة مجانية",
    "from": "من",
    "fromIsRequired": "من المطلوب",
    "fsIsRequired": "مطلوب FS",
    "fuelType": "نوع الوقود",
    "fuelTypeIsRequired": "نوع الوقود مطلوب",
    "fullTime": "دوام كامل",
    "fundingSourceAndValidity": "مطلوب مصدر التمويل ونطاق الصلاحية",
    "fundingSourceLabel": "مصدر التمويل",
    "noViolation": "لا توجد مخالفة",
    "fundingSourceRequired": "مصدر التمويل مطلوب",
    "fundingSources": "مصدر (مصادر) التمويل",
    "fundingSourcesAreRequired": "مصادر التمويل مطلوبة",
    "garage": "المرآب",
    "garageAddress": "عنوان المرآب",
    "garageAddressIsRequired": "عنوان المرآب مطلوب",
    "gasCardNumber": "رقم بطاقة الغاز",
    "gasCardNumberIs": "مطلوب رقم بطاقة الغاز",
    "genderFemale": "أنثى",
    "genderLabel": "الجنس",
    "genderMale": "ذكر",
    "genderOther": "آخر",
    "genderRequired": "الجنس مطلوب",
    "general": "عام",
    "georgia": "جورجيا",
    "gisMiles": "مايلز نظم المعلومات الجغرافية",
    "goBackHome": "العودة إلى المنزل",
    "googleMiles": "جوجل مايلز",
    "groundClearanceIsRequired": "مطلوب الخلوص الأرضي",
    "groupByName": "المجموعة حسب الاسم",
    "groupImageIsRequired": "صورة المجموعة مطلوبة",
    "groupName": "اسم المجموعة",
    "groupNameIsRequired": "اسم المجموعة مطلوب",
    "groups": "المجموعات",
    "gurneyTraining": "تدريب جورني",
    "handsFreeTraining": "تدريب حر اليدين",
    "haversineMiles": "هافيرسين مايلز",
    "height": "ارتفاع",
    "heightIsRequired": "الارتفاع مطلوب",
    "hepatitis": "التهاب الكبد",
    "hhmm": "(سمو: مم)",
    "hhmm2": "هممم",
    "hhmm3": "سمو: مم",
    "hideOneHourException": "إخفاء استثناء ساعة واحدة",
    "hideThirdPartyDrivers": "إخفاء برامج تشغيل الطرف الثالث",
    "hideUnassignedTrips": "إخفاء الرحلات غير المخصصة",
    "hipaaPhiTrainingValid": "تدريب HIPAA / PHI (صالح للأبد)",
    "history": "تاريخ",
    "holidayName": "اسم العطلة",
    "holidayNameIsRequired": "اسم العطلة مطلوب",
    "hoodInformation": "معلومات هود",
    "hospitalized": "في المستشفى",
    "host": "يستضيف",
    "howToUseThe": "🔍 كيفية استخدام البحث",
    "iaal": "ايال",
    "ifYouAlterThe": "إذا قمت بتغيير معلومات الرحلة بحيث لا تتطابق مع تفاصيل الرحلة الفعلية التي تمت، فإنك تقدم بيانًا كاذبًا وترتكب جريمة. سيتم مقاضاة أي شخص يقدم بيانًا كاذبًا إلى أقصى حد يسمح به القانون.",
    "image": "صورة",
    "imageIsRequired": "الصورة مطلوبة",
    "img-corporate": "img-corporate",
    "importFile": "ملف الاستيراد",
    "importingTripsFromBrokers": "استيراد الرحلات من الوسطاء",
    "inActiveReason": "في السبب النشط",
    "inActiveReasonIs": "في السبب النشط مطلوب",
    "inMinutes": "(بالدقائق)",
    "inProgress": "في تَقَدم",
    "inProgressTrips": "رحلات قيد التنفيذ",
    "inProgressRoutes": "مسار قيد التنفيذ",
    "inReview": "قيد المراجعة",
    "inVehicle": "في المركبة",
    "inactive": "غير نشط",
    "incentive": "حافز",
    "incentiveIsRequired": "الحافز مطلوب",
    "indiana": "إنديانا",
    "ineligible": "غير مؤهل",
    "info": "معلومات",
    "informDriver": "إبلاغ السائق",
    "information": "معلومة",
    "inspectionPassOrFail": "مطلوب تصريح التفتيش أو الفشل",
    "interiorInformation": "المعلومات الداخلية",
    "invalidEmailFormat": "تنسيق البريد الإلكتروني غير صالح",
    "invalidTrip": "رحلة غير صالحة",
    "invoice": "فاتورة",
    "invoices": "الفواتير الصادرة",
    "ipaLabel": "رقم IPA / FECA",
    "ipaRequired": "رقم IPA / FECA مطلوب",
    "ipcr": "إيبيكر",
    "isAcknowledgementOnFile": "هل الاعتراف موجود في الملف؟",
    "isCertificateOnFile": "هل الشهادة موجودة في الملف؟",
    "isWave": "هل موجة",
    "issueDate": "تاريخ الإصدار",
    "issueDateIsRequired": "تاريخ الإصدار مطلوب",
    "itineries": "مسارات الرحلة",
    "kpisdriverdisplayname": "kpis.driver.displayName",
    "language": "اللغة",
    "lastInspectionDateIs": "مطلوب تاريخ الفحص الأخير",
    "lastName": "اسم العائلة",
    "lastNameIsRequired": "الاسم الأخير مطلوب",
    "lastNameMustBe": "يجب أن يتكون الاسم الأخير من 3 أحرف على الأقل.",
    "lateCushion": "وسادة متأخرة",
    "lateCushionIsRequired": "الوسادة المتأخرة مطلوبة",
    "lateEta": "وقت متأخر لوقت الوصول المتوقع",
    "lbs": "(رطل)",
    "legCancellationAlert": "تنبيه إلغاء الساق",
    "legLabel": "مسار-",
    "legalInformation": "المعلومات القانونية",
    "legalName": "الاسم القانوني",
    "legalNameIsRequired": "الاسم القانوني مطلوب",
    "legalNameMustBe": "يجب أن يتكون الاسم القانوني من 3 أحرف على الأقل.",
    "lengthIsRequired": "الطول مطلوب",
    "lengthMustBe3": "يجب أن يكون الطول 3",
    "levelOfServiceImage": "صورة ‏مستوى الخدمة‏",
    "levelOfServiceLabel": "مستوى الخدمة",
    "levelOfServiceRequired": "مستوى الخدمة مطلوب",
    "levelofservice-image": "مستوى الخدمة-صورة",
    "licenseInformation": "معلومات الترخيص",
    "licenseNumber": "رقم الترخيص",
    "licenseNumberIsRequired": "رقم الترخيص مطلوب",
    "licensePlate": "لوحة الترخيص",
    "licensePlateInformation": "معلومات لوحة الترخيص",
    "licensePlateIsRequired": "لوحة الترخيص مطلوبة",
    "lightsInformation": "معلومات أضواء",
    "limitation": "القيد",
    "limitations": "القيود",
    "line": "خط",
    "list": "قائمة",
    "listView": "عرض القائمة",
    "livescanDojFbi": "لايفسكان (وزارة العدل + مكتب التحقيقات الفيدرالي)",
    "livescanDojOnly": "LIVESCAN (وزارة العدل فقط)",
    "load": "الحمولة",
    "loadTimeIsRequired": "مطلوب وقت التحميل",
    "loadedMilesRateIs": "معدل الأميال المحملة مطلوب",
    "loadedTime": "وقت التحميل",
    "loadedTimeToDropoff": "وقت التحميل (إلى التوصيل)",
    "loginInformation": "معلومات تسجيل الدخول",
    "logisticareTemplate": "قالب لوجستي كير",
    "logo": "شعار",
    "logout": "تسجيل الخروج",
    "logs": "سجلات",
    "los": "لوس:",
    "losAndSpaceType": "مطلوب Los ونوع المساحة",
    "lt": "إل تي",
    "lt2": "إل تي:",
    "lunch": "استراحة غداء",
    "maintenanceInformation": "معلومات الصيانة",
    "maintenances": "الصيانة",
    "makeItLive": "اجعلها حية",
    "makeModel": "صنع ونموذج",
    "makeModelIsRequired": "مطلوب الصنع والنموذج",
    "mandatoryForCms1500": "(إلزامي لنموذج CMS 1500)",
    "mandatoryForMedicaidAnd": "(إلزامي لنماذج Medicaid وCMS 1500)",
    "mandatoryForMedicaidAuth": "(إلزامي لنموذج مصادقة Medicaid)",
    "manifest": "البيان",
    "manifestLegend": "الأسطورة الظاهرة",
    "manual": "الدليل",
    "manualGenerate": "توليد يدوي",
    "manualTrip": "رحلة يدوية",
    "mapperIsRequired": "مطلوب مصمم الخرائط",
    "markComplete": "وضع علامة كاملة",
    "markMemberReady": "تحديد العضو كجاهز",
    "markedReady": "تم وضع علامة على الاستعداد",
    "markedReadyRoutes": "مسارات جاهزة",
    "markedReadyTrips": "رحلات جاهزة",
    "marketplace": "السوق",
    "maxDistance": "أقصى مسافة:",
    "maxOnboardTime": "الحد الأقصى للوقت على متن الطائرة:",
    "maxTrips": "الرحلات القصوى:",
    "meal": "وجبة",
    "mealBreak": "استراحة وجبة",
    "mechanicverificationsignatur": "ميكانيكيVerification.signature",
    "medex": "ميديكس",
    "medical": "طبي",
    "medicalIdIsRequired": "مطلوب الهوية الطبية",
    "medicalLogo": "الشعار الطبي",
    "medicalTrip": "رحلة طبية",
    "member-image": "صورة العضو",
    "memberLabel": "العضو",
    "memberLoading": "تحميل الأعضاء",
    "memberName": "اسم العضو",
    "memberNotVisible": "العضو غير مرئي",
    "memberOnboard": "عضو على متن الطائرة",
    "memberOnboardAt": "عضو على متن الطائرة في:",
    "memberRequired": "العضو مطلوب",
    "memberRoleIsRequired": "دور العضو مطلوب",
    "memberStatus": "حالة العضو",
    "memberType": "نوع العضو",
    "memberTypeIsRequired": "نوع العضو مطلوب",
    "memberdisplayname": "اسم العرض",
    "membersPhoneNumber": "رقم هاتف العضو",
    "merge": "دمج",
    "messageAlerts": "تنبيهات الرسائل",
    "messages": "رسائل",
    "methadone": "الميثادون",
    "method": "طريقة",
    "methodIsRequired": "الطريقة مطلوبة",
    "mfa": "(وزارة الخارجية)",
    "mfb": "MFB",
    "mi": "mi",
    "mid": "منتصف",
    "middleName": "الاسم الأوسط",
    "middleNameIsRequired": "الاسم الأوسط مطلوب",
    "mile": "ميل",
    "miles": "أميال",
    "milesForBucksDriver": "مايلز لسائق باكس",
    "milesForBucksPanel": "مايلز للوحة باكز",
    "milesLabel": "أميال",
    "milesRequired": "عدد الأميال مطلوب",
    "minimum3CharactersRequired": "مطلوب 3 أحرف على الأقل",
    "minimum5CharactersRequired": "الحد الأدنى 5 أحرف مطلوبة",
    "mins": "دقيقة",
    "minutes": "دقائق",
    "minutesIsRequired": "مطلوب دقائق",
    "mm": "(مم)",
    "mmddyyyy": "ش ش/ي ي/س س س س",
    "mobileNumberLabel": "رقم الجوال",
    "mobileNumberRequired": "رقم الجوال مطلوب",
    "model": "نموذج",
    "modelIsRequired": "النموذج مطلوب",
    "modifierLabel": "المعدل",
    "modifierRequired": "المعدل مطلوب",
    "moicu": "وزارة التجارة والصناعة",
    "moreFeaturesComingSoon": "📝 المزيد من الميزات قريبا",
    "moreLabel": "إضافي...",
    "na": "لا يوجد",
    "name": "اسم",
    "nameIsRequired": "الاسم مطلوب",
    "nemt": "NEMT",
    "nemtStatistics": "إحصائيات NEMT",
    "newExpense": "حساب جديد",
    "newInspection": "التفتيش الجديد",
    "newPassword": "كلمة المرور الجديدة",
    "newPasswordIsRequired": "كلمة المرور الجديدة مطلوبة",
    "no": "لا",
    "noAgentTripsTo": "لا توجد رحلات وكيل لإظهارها",
    "noAnswer": "لا إجابة",
    "noCompanyDetailsTo": "لا توجد تفاصيل الشركة للعرض",
    "noCtcTripTo": "لا توجد رحلة CTC للعرض",
    "noDataToShow": "لا توجد بيانات لإظهارها",
    "noDetailsToShow": "لا توجد تفاصيل للعرض",
    "noDirtRoadTrips": "لا توجد رحلات على الطرق الترابية للعرض",
    "noDriverDetailsTo": "لا توجد تفاصيل للسائق لإظهارها",
    "noEarning": "لا كسب",
    "noEarningsToShow": "لا توجد أرباح للعرض",
    "noMessageToShow": "لا توجد رسالة لإظهارها",
    "noNotificationsToShow": "لا توجد إشعارات للعرض",
    "noOfEscortsLabel": "عدد المرافقين",
    "noOfEscortsRequired": "عدد المرافقين مطلوب",
    "noOfRoutes": "عدد الطرق",
    "noOfRoutesAre": "عدد الطرق مطلوبة",
    "noOfSeats": "عدد المقاعد",
    "noOfSeatsAre": "عدد المقاعد مطلوب",
    "noParsedFileFound": "لم يتم العثور على ملف تم تحليله",
    "noRecords": "لا توجد سجلات",
    "noShowCharges": "عدم عرض الرسوم",
    "noShowChargesIs": "لا يلزم إظهار الرسوم",
    "noStatisticsToShow": "لا توجد إحصائيات للعرض",
    "noTripLogsTo": "لا توجد سجلات رحلة لإظهارها",
    "noTripsAssign": "لم يتم تعيين رحلات",
    "noTripsToShow": "لا توجد رحلات للعرض",
    "noUnassignedTrips": "لا توجد رحلات غير مخصصة",
    "non-transportVehicle": "مركبة غير النقل",
    "none": "لا أحد",
    "notAvailable": "غير متوفر",
    "notEligible": "غير مؤهل",
    "note": "ملحوظة",
    "notes": "ملحوظات",
    "notesAreRequired": "الملاحظات مطلوبة",
    "notificationMethod": "طريقة الإخطار",
    "notifications": "إشعارات",
    "odometer": "عداد المسافات",
    "odometerBegin": "يبدأ عداد المسافات",
    "odometerBeginIsRequired": "مطلوب بداية عداد المسافات",
    "odometerBeginReadingIs": "مطلوب عداد المسافات لبدء القراءة",
    "odometerEndIsRequired": "مطلوب نهاية عداد المسافات",
    "odometerRequired": "مطلوب عداد المسافات",
    "odometerStart": "بداية عداد المسافات",
    "odometerStartIsRequired": "مطلوب بدء عداد المسافات",
    "odometerStop": "توقف عداد المسافات",
    "odometerStopIsRequired": "مطلوب توقف عداد المسافات",
    "of": "من",
    "offeredAccepted": "معروض / مقبول",
    "offeredTrips": "رحلات معروضة",
    "offline": "غير متصل",
    "oigScreening": "فحص مكتب المفتش العام",
    "onScene": "على الساحة:",
    "onScene2": "على المشهد",
    "onSceneReport": "تقرير عن المشهد",
    "onWay": "على الطريق",
    "onWayAt": "في الطريق إلى:",
    "onboard": "صعد على متنها",
    "oneHourException": "استثناء ساعة واحدة",
    "onq": "أونكيو",
    "onscene": "على المشهد",
    "onsceneTimeIsRequired": "وقت التواجد مطلوب",
    "onway": "في الطريق",
    "open": "يفتح",
    "openMainMenu": "فتح القائمة الرئيسية",
    "openUserMenu": "فتح قائمة المستخدم",
    "opener": "فتاحة",
    "operations": "العمليات",
    "operationsManager": "مدير العمليات",
    "operationsManagerIsRequired": "مطلوب مدير العمليات",
    "optIn": "اختيار في",
    "orDragAndDrop": "أو السحب والإفلات",
    "ordAct": "ترتيب/فعل",
    "order": "طلب",
    "orderIsRequired": "الطلب مطلوب",
    "organizationId": "معرف المنظمة",
    "organizationIdIsRequired": "معرف المنظمة مطلوب",
    "otherInformation": "معلومات أخرى",
    "otherLegsHeader": "مسارات أخرى",
    "others": "آحرون",
    "otp": "مكتب المدعي العام",
    "outsideShift": "خارج الوردية",
    "outstandingTrips": "رحلات معلقة",
    "ownerDetails": "تفاصيل المالك",
    "pageNotFound": "لم يتم العثور على الصفحة",
    "paid": "Paid",
    "panel": "لوحة",
    "parseTrips": "رحلات التحليل",
    "partTime": "دوام جزئى",
    "partner": "الشريك",
    "passenger": "راكب",
    "passengerAssistanceAndCultur": "مساعدة الركاب والتدريب الثقافي (EXP)",
    "passengerInformation": "معلومات الركاب",
    "password": "كلمة المرور",
    "passwordInformation": "معلومات كلمة المرور",
    "passwordIsRequired": "كلمة المرور مطلوبة",
    "passwordMustBeAtleast": "يجب أن تكون كلمة المرور مكونة من 6 أحرف على الأقل",
    "passwordMustBeAtleast2": "يجب أن تتكون كلمة المرور من 6 أحرف على الأقل",
    "passwordMustBeMaximum": "يجب أن تتكون كلمة المرور من 16 حرفًا كحد أقصى",
    "passwordMustBeMaximum2": "يجب أن تتكون كلمة المرور من 16 حرفًا كحد أقصى",
    "patient": "مريض",
    "paymentConfirmed": "تم تأكيد الدفع",
    "paymentUnconfirmed": "الدفع غير مؤكد",
    "payorLabel": "الدافع",
    "pending": "قيد الانتظار",
    "pendingFee": "الرسوم المعلقة *",
    "perMile": "لكل ميل",
    "perMileCode": "رمز لكل ميل",
    "perMileCodeIs": "مطلوب رمز لكل ميل",
    "perMileIsRequired": "مطلوب لكل ميل",
    "perMinIsRequired": "مطلوب لكل دقيقة",
    "perMinute": "في الدقيقة",
    "period": "فترة",
    "permissions": "الأذونات",
    "person": "الشخص",
    "phoneNumberLabel": "رقم الهاتف",
    "phoneNumberRequired": "رقم الهاتف مطلوب",
    "pickupAddress": "عنوان الاستلام",
    "pickupAddressIsRequired": "عنوان الالتقاط مطلوب",
    "pickupEarly": "الاستلام مبكرًا:",
    "pickupHeader": "نقطة الالتقاط",
    "pickupLate": "الاستلام متأخرًا:",
    "pickupLateReason": "سبب التأخر في الاستلام",
    "pickupLateReasons": "أسباب التأخر في الاستلام:",
    "pickupTme": "بيك اب تيم",
    "pickupWise": "بيك اب حكيم",
    "placeNameLabel": "اسم المنزل/المنشأة",
    "placeNameRequired": "اسم المنزل/المنشأة مطلوب",
    "planner": "المخطط",
    "platform": "منصة",
    "platformIsRequired": "المنصة مطلوبة",
    "platformportal": "المنصة/البوابة",
    "platformportalIsRequired": "المنصة/البوابة مطلوبة",
    "pleaseChooseAnyAbove": "الرجاء اختيار أي سبب أعلاه",
    "pleaseEnterDispatcherNotes": "الرجاء إدخال ملاحظات المرسل",
    "pleaseEnterForDriver": "الرجاء إدخال ملاحظات السائق",
    "pleaseEnterTheClient": "الرجاء إدخال اسم العميل",
    "pleaseEnterTheDate": "الرجاء إدخال تاريخ فحص سجل السيارة الخاص بالسائق",
    "pleaseEnterTheDescription": "الرجاء إدخال الوصف",
    "pleaseEnterTheNote": "الرجاء إدخال الملاحظة",
    "pleaseEnterTheNotes": "الرجاء إدخال الملاحظات",
    "pleaseEnterThePrivate": "الرجاء إدخال الملاحظة الخاصة",
    "pleaseEnterTheTime": "الرجاء إدخال المنطقة الزمنية",
    "pleaseNoteByUsing": "يرجى ملاحظة أنه باستخدام هذه الميزة، يجب عليك حذف أي رحلات لم يتم إجراؤها على الأرض حتى لا يتم اختلاق أي معلومات على النظام.",
    "pleaseSelectAtLeast": "الرجاء اختيار سائق واحد على الأقل.",
    "pleaseSelectCompanyTo": "الرجاء اختيار الشركة لعرض السجل",
    "pleaseSelectPrimaryMember": "الرجاء اختيار العضو الأساسي",
    "pleaseSelectTimeIn": "الرجاء تحديد الوقت في",
    "pleaseTakeNoticeFiling": "يرجى أخذ العلم: تقديم بيانات كاذبة يعد جريمة",
    "pngJpgGifUp": "PNG، JPG، GIF حتى 10 ميجابايت",
    "policeClearance": "تخليص الشرطة",
    "port": "ميناء",
    "portIsRequired": "المنفذ مطلوب",
    "position": "موضع",
    "positionIsRequired": "المنصب مطلوب",
    "possibilityButton": "إمكانية",
    "primary": "أساسي",
    "primaryDiagnoseLabel": "التشخيص الرئيسي",
    "primaryDiagnoseRequired": "التشخيص الرئيسي مطلوب",
    "priority": "Priority",
    "priorityIsRequired": "الأولوية مطلوبة",
    "privateLabel": "(خاص)",
    "privateNote": "ملاحظة خاصة",
    "proceed": "يتابع",
    "proficiency": "الكفاءة",
    "proficiencyIsRequired": "مطلوب الكفاءة",
    "profile": "حساب تعريفي",
    "profileImage": "صورة الملف الشخصي",
    "profileImageIsRequired": "صورة الملف الشخصي مطلوبة",
    "profileInformation": "معلومات الملف الشخصي",
    "profileOverview": "نظرة عامة على الملف الشخصي",
    "profileimage": "Profile_image",
    "protips": "نصائح احترافية",
    "proposedReadyTime": "وقت الاستعداد المقترح",
    "pu": "استلام",
    "puModifier": "معدل بو",
    "puModifierIsRequired": "مطلوب معدل PU",
    "pua": "عنوان الاستلام",
    "publicLabel": "(عام)",
    "pull-Out": "سحب للخارج",
    "pullEnd": "سحب / نهاية",
    "punjabiLanguageLabel": "البنجابية",
    "put": "وقت الاستلام",
    "quantityLabel": "الكمية",
    "quantityRequired": "الكمية مطلوبة",
    "quarterdisplayname": "ربع.اسم العرض",
    "quickFilter": "تصفية سريعة",
    "quickSearch": "بحث سريع",
    "quickSearchGuide": "🔍 دليل البحث السريع",
    "radiusIsRequired": "الشعاع مطلوب",
    "rates": "الأسعار",
    "rawReport": "تقرير خام",
    "re-assign": "إعادة التعيين",
    "readyNotes": "ملاحظات جاهزة",
    "reason": "سبب",
    "reasonIsRequired": "السبب مطلوب",
    "recurringDays": "الأيام المتكررة",
    "recurringStatusRequired": "حالة التكرار مطلوبة",
    "refS": "المرجع #ق",
    "reference": "المرجع",
    "reg": "التسجيل:",
    "regular": "عادي",
    "reject": "يرفض",
    "rejected": "مرفوض",
    "rejectedTrips": "رحلات مرفوضة",
    "relation": "العلاقة",
    "relationIsRequired": "العلاقة مطلوبة",
    "removeButton": "إزالة",
    "reply": "رد",
    "reports": "التقارير",
    "representativesignature": "توقيع",
    "requiredOdometers": "عدادات المسافات المطلوبة",
    "rescheduleTrip": "إعادة جدولة الرحلة",
    "resendCode": "إعادة إرسال الرمز؟",
    "reservationNo": "رقم الحجز:",
    "reset": "إعادة ضبط",
    "resetPassword": "إعادة تعيين كلمة المرور",
    "responseNightCode": "رمز الاستجابة الليلية",
    "responseNightCodeIs": "مطلوب رمز ليلة الاستجابة",
    "rest": "استراحة",
    "restBreak": "استراحة الراحة",
    "return": "يعود",
    "revenue": "ربح",
    "reviewUrl": "مراجعة عنوان URL",
    "rfLfRrLr": "(RF LF RR LR)",
    "rigNo": "رقم الجهاز",
    "rigNoIsRequired": "تلاعب لا مطلوب",
    "ripplingId": "معرف تموج",
    "ripplingIdIsRequired": "مطلوب معرف امتد",
    "rode": "تم الركوب",
    "roleIsRequired": "الدور مطلوب",
    "roleType": "نوع الدور",
    "roleTypeIsRequired": "نوع الدور مطلوب",
    "roomLabel": "الغرفة",
    "roomRequired": "الغرفة مطلوبة",
    "routeDetails": "تفاصيل المسار",
    "routeView": "عرض الطريق",
    "samScreening": "فحص سام",
    "save": "يحفظ",
    "saveForAll": "حفظ للجميع",
    "saveTemplate": "حفظ القالب",
    "scheduleShells": "جدولة الصدفة (الصدفات)",
    "scheduleShellsIsRequired": "مطلوب الجدول الزمني (ق) شل",
    "scheduleTime": "جدولة الوقت",
    "scheduleTimeIsRequired": "وقت الجدول الزمني مطلوب",
    "scheduledTrips": "الرحلات المجدولة",
    "score": "نتيجة",
    "scoreDetails": "تفاصيل النتيجة",
    "search": "يبحث",
    "search2": "يبحث...",
    "searchCompany": "شركة البحث",
    "searchDriver": "سائق البحث",
    "searchGroup": "مجموعة البحث",
    "searchMessages": "البحث في الرسائل",
    "searchVehicle": "بحث مركبة",
    "seconds": "(ثواني)",
    "secureComplianceTrainingAckn": "إقرار التدريب على الامتثال الآمن",
    "secureType": "نوع آمن",
    "seeAll": "رؤية الكل",
    "seenBy": "تمت مشاهدته بواسطة",
    "selectAddonItemPlaceholder": "-- اختر العنصر --",
    "selectAll": "حدد الكل",
    "selectAppointmentDirectionPlaceholder": "-- اختر اتجاه الموعد --",
    "selectAppointmentTypePlaceholder": "-- اختر نوع الموعد --",
    "selectAssistsPlaceholder": "-- اختر المساعدات --",
    "selectBreak": "حدد فاصل",
    "selectCorporate": "حدد الشركة",
    "selectDate": "حدد التاريخ",
    "selectDateRange": "حدد النطاق الزمني",
    "selectDos": "حدد دوس",
    "selectDriver": "حدد برنامج التشغيل",
    "selectDriverPlaceholder": "-- اختر السائق --",
    "selectFundingSource": "حدد مصدر التمويل",
    "selectFundingSourcePlaceholder": "-- اختر مصدر التمويل --",
    "selectGenderPlaceholder": "-- اختر الجنس --",
    "selectLevelOfService": "حدد مستوى الخدمة",
    "selectLevelOfServicePlaceholder": "-- اختر مستوى الخدمة --",
    "selectMember": "اختر عضوا",
    "selectMemberPlaceholder": "-- اختر العضو --",
    "selectModifierPlaceholder": "-- اختر المعدل --",
    "selectNoOfEscortsPlaceholder": "-- اختر عدد المرافقين --",
    "selectPayorPlaceholder": "-- اختر الدافع --",
    "selectPrimaryDiagnosePlaceholder": "-- اختر التشخيص الرئيسي --",
    "selectServiceArea": "حدد منطقة الخدمة",
    "selectServiceAreaPlaceholder": "-- اختر منطقة الخدمة --",
    "selectSpaceType": "حدد نوع المساحة",
    "selectSpaceTypePlaceholder": "-- اختر نوع المساحة --",
    "selectStatus": "حدد الحالة",
    "selectTime": "حدد الوقت",
    "selectTimezone": "حدد المنطقة الزمنية",
    "selectType": "اختر النوع",
    "selectedDriverIsRequired": "برنامج التشغيل المحدد مطلوب",
    "selectedServiceAreaIs": "منطقة الخدمة المحددة مطلوبة",
    "selectedTrip": "رحلة مختارة",
    "send": "يرسل",
    "sendCode": "إرسال الرمز",
    "sendEmail": "إرسال البريد الإلكتروني",
    "sendOnBreak": "إرسال في استراحة",
    "sentYouAnInvite": "أرسلت لك دعوة للتواصل.",
    "serviceAreaLabel": "منطقة الخدمة",
    "serviceAreaRequired": "منطقة الخدمة مطلوبة",
    "serviceAreas": "منطقة (مناطق) الخدمة",
    "serviceAreasIsRequired": "منطقة (مناطق) الخدمة مطلوبة",
    "serviceNameIsRequired": "اسم الخدمة مطلوب",
    "serviceRepresentative": "ممثل الخدمة",
    "services": "خدمات",
    "setBsr": "قم بتعيين BSR",
    "setTags": "تعيين العلامات",
    "setiD": "سيتي د:",
    "settings": "إعدادات",
    "sexOffenderBackgroundCheck": "التحقق من خلفية مرتكبي الجرائم الجنسية",
    "sexualHarassmentTraining": "التدريب على التحرش الجنسي",
    "shift": "يحول:",
    "shift-End": "التحول - النهاية",
    "shiftAlign": "محاذاة التحول",
    "shiftAlignIsRequired": "مطلوب محاذاة التحول",
    "shiftDayWise": "التحول (اليوم الحكيم)",
    "shiftEnd": "نهاية التحول",
    "shiftEndIsRequired": "مطلوب نهاية التحول",
    "shiftMarker": "علامة التحول",
    "shiftOverride": "تجاوز الوردية",
    "shiftOverrideNotAvailable": "تجاوز الوردية (غير متاح)",
    "shiftStart": "بداية التحول",
    "shiftStartIsRequired": "مطلوب التحول البداية",
    "shifts": "الورديات",
    "showBreak": "عرض استراحة",
    "showGoogleMiles": "عرض أميال جوجل",
    "showRoute": "عرض الطريق",
    "showUnassignedTrips": "عرض الرحلات غير المخصصة",
    "signIn": "تسجيل الدخول",
    "signInToYour": "قم بتسجيل الدخول إلى حسابك",
    "signature": "إمضاء",
    "signatureIsRequired": "التوقيع مطلوب",
    "single": "أعزب",
    "skipSignature": "تخطي التوقيع",
    "smokeFreeVehiclesDriver": "مركبات خالية من التدخين (فهم السائق)",
    "sms": "رسالة قصيرة",
    "sms/dashboard": "لوحة رسائل SMS",
    "smsRequired": "مطلوب الرسائل القصيرة",
    "sorryWeCouldntFind": "عذرًا، لم نتمكن من العثور على الصفحة التي تبحث عنها.",
    "sort": "نوع",
    "spaceTypeLabel": "نوع المساحة",
    "spaceTypeRequired": "نوع المساحة مطلوب",
    "spaceTypefileIsRequired": "نوع المساحة (ملف) مطلوب",
    "spaceTypesIsRequired": "نوع (أنواع) المساحة مطلوب",
    "spacetypeImage": "صورة ‏نوع المسافة‏",
    "spacetypeIsRequired": "SpaceType is required",
    "spacetypes": "نوع (أنواع) الفضاء",
    "spanishLanguageLabel": "الإسبانية",
    "specialFare": "أجرة خاصة",
    "specialRequests": "طلبات خاصة",
    "squareImageIsRecommended": "* يوصى باستخدام صورة مربعة",
    "ssl": "ssl",
    "staff": "(طاقم عمل)",
    "stagingTrips": "رحلات التدريج",
    "stairsSteps": "خطوة / خطوات الدرج",
    "stairsStepsIsRequired": "خطوة/خطوات السلالم مطلوبة",
    "standingOrderHeader": "طلب دائم",
    "startDate": "تاريخ البدء",
    "startDateIsRequired": "تاريخ البدء مطلوب",
    "startTime": "وقت البدء",
    "startTimeIsRequired": "وقت البدء مطلوب",
    "started": "بدأت",
    "startedAt": "بدأت في:",
    "startedTimeIsRequired": "وقت البدء مطلوب",
    "statReport": "تقرير الإحصائيات",
    "stateCode": "كود الدولة",
    "stateCodeIsRequired": "مطلوب رمز الدولة",
    "stateIsRequired": "الدولة مطلوبة",
    "statistics": "إحصائيات",
    "statusActive": "نشط",
    "statusInactive": "غير نشط",
    "statusIsRequired": "الحالة مطلوبة",
    "statusLabel": "الحالة",
    "statuses": "الحالات",
    "statuss": "الحالة (الحالات)",
    "stop": "قف",
    "stopTimeIsRequired": "مطلوب وقت التوقف",
    "storageInformation": "معلومات التخزين",
    "submit": "يُقدِّم",
    "suggestTime": "أقترح الوقت",
    "suggestedTime": "الوقت المقترح",
    "support": "الدعم الفني",
    "svc": "الخدمة",
    "sweep": "اكتساح",
    "sweepFile": "ملف الاجتياح",
    "table": "جدول",
    "table-user": "مستخدم الجدول",
    "takeSignature": "خذ التوقيع",
    "taxInformation": "المعلومات الضريبية",
    "taxonomyCode": "رمز التصنيف",
    "tbTest": "اختبار السل",
    "template": "نموذج",
    "templateIsRequired": "القالب مطلوب",
    "textAssistanceRequiredFor": "المساعدة النصية المطلوبة للعضو.",
    "textLiveLinkTo": "نص رابط مباشر للعضو",
    "thirdParty": "طرف ثالث",
    "thisOperationWillComplete": "ستكمل هذه العملية المعلومات المطلوبة لإنشاء ملفات مطالبات التأمين مثل سجلات الرحلات ونماذج TRF وما إلى ذلك.",
    "threshold": "عتبة",
    "thresholdIsRequired": "العتبة مطلوبة",
    "timeCalibration": "معايرة الوقت",
    "timeFormat": "تنسيق الوقت",
    "timeFormatIsRequired": "تنسيق الوقت مطلوب",
    "timeIn": "الوقت في",
    "timeInAt": "الوقت في",
    "timeInIsRequired": "الوقت مطلوب",
    "timeLabel": "الوقت",
    "timeOut": "نفذ الوقت",
    "timeOutIsRequired": "مطلوب المهلة",
    "timeRequired": "الوقت مطلوب",
    "timeZone": "المنطقة الزمنية",
    "timeZoneIsRequired": "المنطقة الزمنية مطلوبة",
    "timein": "الوقت",
    "timeline": "الجدول الزمني",
    "timelines": "الجدول الزمني",
    "times": "×",
    "tipStatusIsRequired": "حالة النصيحة مطلوبة",
    "tipTitleIsRequired": "عنوان النصيحة مطلوب",
    "tiresInformation": "معلومات الإطارات",
    "title": "عنوان",
    "titleIsRequired": "العنوان مطلوب",
    "tls": "tls",
    "to": "ل",
    "toIsRequired": "الى مطلوب",
    "today": "اليوم",
    "toll-freeNumber": "الرقم المجاني",
    "toll-freeNumberIsRequired": "الرقم المجاني مطلوب",
    "totalFare": "إجمالي الأجرة",
    "totalFareIsRequired": "مطلوب إجمالي الأجرة",
    "tp": "(تب)",
    "traffic": "المرور",
    "travelAndSequence": "السفر والتسلسل",
    "trial": "محاكمة",
    "trialEnd": "نهاية المحاكمة",
    "tripAssistance": "مساعدة الرحلة",
    "tripId": "معرف الرحلة",
    "tripIdLabel": "معرف الرحلة",
    "tripIdRequired": "معرف الرحلة مطلوب",
    "tripInformation": "معلومات الرحلة",
    "tripLogs": "سجلات الرحلة",
    "tripQuota": "حصة الرحلة",
    "tripQuotaIsRequired": "حصة الرحلة مطلوبة",
    "tripReport": "تقرير الرحلة",
    "tripRoute": "طريق الرحلة",
    "tripS": "رحلة(رحلات)",
    "tripSequenceLate": "تسلسل الرحلة (متأخر)",
    "tripSequenceOnTime": "تسلسل الرحلة (في الوقت)",
    "tripStatus": "حالة الرحلة",
    "tripWise": "رحلة حكيمة",
    "trips": "الرحلات",
    "tripsAdjustmentImportant": "تعديل الرحلات (مهم قبل الفوترة)",
    "tripsFile": "ملف الرحلات",
    "tripsFileIsRequired": "مطلوب ملف الرحلات",
    "tripsItinerary": "خط سير الرحلات",
    "tripsMapDashboard": "لوحة معلومات خريطة الرحلات",
    "type": "يكتب",
    "typeAMessage": "اكتب رسالة .....",
    "un-selectAll": "قم بإلغاء تحديد الكل",
    "unassign": "إلغاء التعيين",
    "unassigned": "غير معين",
    "unassignedCancelled": "تم الإلغاء غير المعين",
    "unassignedTrips": "الرحلات غير المعينة",
    "unconfirm": "غير مؤكد",
    "undo": "تراجع",
    "unknown": "مجهول",
    "unloadTimeIsRequired": "مطلوب وقت التفريغ",
    "unscheduled": "[غير مجدول]",
    "upBaseAddress": "العنوان الأساسي",
    "updateAssists": "مساعدات التحديث",
    "updateButton": "تحديث",
    "updateStatus": "تحديث الحالة",
    "uploadAFile": "تحميل ملف",
    "uploadAnImage": "تحميل صورة",
    "uploadJpegJpgOr": "قم بتحميل ملف بتنسيق .jpeg أو .jpg أو png",
    "uploadTxtFile": "تحميل ملف .txt",
    "uploadXlsxXlsOr": "قم بتحميل ملف .xlsx أو .xls أو .csv",
    "urduLanguageLabel": "الأردية",
    "url": "عنوان URL",
    "useAPermanentAddress": "استخدم عنوانًا دائمًا حيث يمكنك تلقي البريد.",
    "useAuthenticSignatures": "استخدم التوقيعات الأصلية.",
    "useMemberPermanentAddress": "استخدم العنوان الدائم للعضو حيث يمكنه تلقي البريد.",
    "useSettingAriaLabel": "استخدام الإعداد",
    "user": "مستخدم",
    "user-image": "صورة المستخدم",
    "user-img": "user-img",
    "userPhoto": "صورة المستخدم",
    "username": "اسم المستخدم",
    "usernameIsRequired": "اسم المستخدم مطلوب",
    "users": "المستخدمين",
    "usingTheBelowForm": "باستخدام النموذج أدناه لإضافة تكوين وسيط جديد",
    "usingTheBelowForm2": "باستخدام النموذج أدناه لإضافة تكوين البريد الإلكتروني الجديد",
    "v1": "V1",
    "v2": "V2",
    "v3": "V3",
    "validityRange": "نطاق الصلاحية",
    "validityRangeIsRequired": "نطاق الصلاحية مطلوب",
    "vehicle": "عربة",
    "vehicleDecalNumberIs": "مطلوب رقم ملصق السيارة",
    "vehicleGarage": "مرآب المركبات",
    "vehicleIdentificationNumberI": "رقم تعريف المركبة مطلوب",
    "vehicleImageBack": "صورة المركبة مرة أخرى",
    "vehicleImageFront": "واجهة صورة السيارة",
    "vehicleImageLeft": "صورة المركبة على اليسار",
    "vehicleImageRight": "صورة المركبة صحيحة",
    "vehicleInspectionInPast": "فحص المركبة خلال الـ 12 شهرًا الماضية مع فترة مراجعة.",
    "vehicleMakeIsRequired": "مطلوب نوع السيارة",
    "vehicleRecordCheckDot": "فحص سجل المركبة (DOT MVR)",
    "vehicleRecordCheckStandard": "فحص سجل المركبة (الفحص القياسي)",
    "vehicleServiceNumberIs": "مطلوب رقم خدمة المركبة",
    "vehicleTypeIsRequired": "نوع المركبة مطلوب",
    "vehicleWise": "مركبة حكيمة",
    "vehiclesFleet": "المركبات / الأسطول",
    "verifyCode": "التحقق من الرمز",
    "viewRoute": "عرض الطريق",
    "viewTripsOnly": "عرض الرحلات فقط",
    "vin": "رقم VIN",
    "vinIsRequired": "مطلوب رقم VIN",
    "violationIsRequired": "المخالفة مطلوبة",
    "violationSets": "مجموعات المخالفات",
    "vipExpiryDate": "تاريخ انتهاء صلاحية VIP",
    "vipExpiryDateIs": "مطلوب تاريخ انتهاء صلاحية VIP",
    "vipLabel": "VIP",
    "vipMembers": "أعضاء كبار الشخصيات",
    "virginia": "فرجينيا",
    "visit": "يزور",
    "voicemail": "البريد الصوتي",
    "waitTime": "وقت الانتظار",
    "waitTimeCode": "رمز وقت الانتظار",
    "waitTimeCodeIs": "رمز وقت الانتظار مطلوب",
    "waitTimeIsRequired": "مطلوب وقت الانتظار",
    "wandererRisk": "خطر الهائم",
    "warning": "تحذير",
    "weekendNightCode": "كود ليلة نهاية الأسبوع",
    "weekendNightCodeIs": "رمز ليلة نهاية الأسبوع مطلوب",
    "weeklyFee": "الرسوم الأسبوعية",
    "weeklyFeeIsRequired": "مطلوب رسوم أسبوعية",
    "weightLabel": "الوزن",
    "weightRequired": "الوزن مطلوب",
    "wheelchairRampInformation": "معلومات منحدر الكرسي المتحرك",
    "wheelchairSecurementTraining": "التدريب على تأمين الكراسي المتحركة (EXP)",
    "widthIsRequired": "العرض مطلوب",
    "willCall": "اتصال عند الطلب",
    "willCall2359": "اتصال عند الطلب (23:59)",
    "willCallActivated": "سوف ندعو المنشط",
    "willCallBracket": "[عند الطلب]",
    "willCallLabel": "عند الطلب",
    "willCallTrip": "سوف نتصل بالرحلة",
    "wmrNumber": "رقم WMR",
    "wmrNumberIsRequired": "رقم WMR مطلوب",
    "writeYourCommentHere": "أكتب تعليقك هنا...",
    "yamsolLlc": "يامسول ذ.م.م",
    "year": "سنة",
    "yearIsRequired": "السنة مطلوبة",
    "yes": "نعم",
    "yourCompany": "شركتك",
    "yourLicenseIsGoing": "ستنتهي صلاحية ترخيصك في 22/11/2020. يرجى تجديد وتحديث الترخيص الخاص بك في Hoosier Transportation لتجنب أي إزعاج.",
    "zipCode": "الرمز البريدي",
    "zipCodeIsRequired": "الرمز البريدي مطلوب",
    "zipIsRequired": "الرمز البريدي مطلوب",
    "zoneForIsRequired": "مطلوب منطقة ل",
    "zoneName": "اسم المنطقة",
    "zones": "المناطق",
    "zoom": "تكبير",
    "id": "معرف",
    "escort": "مرافق",
    "spRate": "سعر خاص",
    "estFare": "التعرفة المقدرة",
    "createdTime": "وقت الإنشاء",
    "authNumber": "رقم التصريح",
    "appointmentTypes": "نوع (أنواع) المواعيد",
    "dvNotes": "ملاحظات السائق",
    "source": "المصدر",
    "trackingNo": "رقم التتبع",
    "roleOrSource": "الدور/المصدر",
    "staffManager": "مدير الموظفين",
    "mobileNumber": "رقم الهاتف المحمول",
    "updatedAt": "تاريخ التحديث",
    "createdAt": "تاريخ الإنشاء",
    "version": "الإصدار",
    "shiftLabel": "وردية",
    "role": "الدور",
    "puTime": "وقت الاستلام",
    "doTime": "وقت التسليم",
    "puDate": "تاريخ الاستلام",
    "doDate": "تاريخ التسليم",
    "memberInfo": "معلومات العضو",
    "facilityVeh": "المنشأة - المركبة",
    "noMemberName": "رقم/اسم العضو",
    "dosLabel": "تاريخ الخدمة",
    "losLabel": "مستوى الخدمة",
    "pickupTime": "وقت الاستلام",
    "dropoffTime": "وقت التسليم",
    "mileage": "الأميال",
    "reservationNoLabel": "رقم الحجز",
    "claimed": "تمت المطالبة بها",
    "onboardStatus": "حالة الانضمام",
    "insurance": "تأمين",
    "loadTime": "وقت التحميل",
    "unloadTime": "وقت التفريغ",
    "totalTrips": "إجمالي الرحلات",
    "totalIntake": "إجمالي الإيرادات",
    "serviceCharges": "رسوم الخدمة",
    "companyIntake": "إيرادات الشركة",
    "remainingAmount": "المبلغ المتبقي",
    "cashPayment": "الدفع النقدي",
    "creditPayment": "الدفع بالبطاقة",
    "adjustedAmount": "المبلغ المعدل",
    "balance": "الرصيد",
    "driverEarnings": "أرباح السائق",
    "earnings": "الأرباح",
    "cash": "نقدي",
    "credit": "ائتمان",
    "adjusted": "معدل",
    "total": "الإجمالي",
    "early": "مبكر",
    "onTime": "في الوقت المحدد",
    "late": "متأخر",
    "earlyTimeScore": "درجة الوقت المبكر",
    "onTimeScore": "درجة في الوقت المحدد",
    "lateTimeScore": "درجة الوقت المتأخر",
    "actualOnTimeScore": "درجة الوقت الفعلي المحدد",
    "aptTime": "وقت الموعد",
    "arrivedTime": "وقت الوصول",
    "message": "الرسالة",
    "error": "خطأ",
    "sentDate": "تاريخ الإرسال",
    "createdDate": "تاريخ الإنشاء",
    "memberId": "معرف العضو",
    "otpStatus": "حالة OTP",
    "otpMinutes": "دقائق OTP",
    "oneHourViolation": "مخالفة ساعة واحدة",
    "filePath": "مسار الملف",
    "mrnLabel": "رقم سجل العضو (MRN)",
    "timestamps": "الطوابع الزمنية",
    "trackId": "رقم التتبع",
    "location": "موقع",
    "report": "تقرير",
    "currentMileage": "الأميال الحالية",
    "inspectedBy": "تم فحصها من قبل",
    "inspectionCenter": "مركز الفحص",
    "result": "النتيجة",
    "passed": "مقبول",
    "failed": "فاشل",
    "dateCorrected": "تاريخ التصحيح",
    "frontDriverPassengerCompartment": "حجرة السائق الأمامية / الركاب",
    "patientCompartment": "مقصورة المريض",
    "exteriorVehicle": "السيارة الخارجية",
    "underHoodCompartment": "تحت غطاء المحرك / المقصورة",
    "fluidsEngine": "السوائل / المحرك",
    "brakeTest": "اختبار الفرامل",
    "tiresWheels": "الإطارات / العجلات",
    "brakes": "الفرامل",
    "bodyFrame": "الهيكل والإطار",
    "fuelSystem": "نظام الوقود",
    "exhaustSystem": "نظام العادم",
    "cost": "التكلفة",
    "category": "الفئة",
    "shiftTime": "وقت المناوبة",
    "timeInTimeOut": "الوقت في/وقت الخروج",
    "mealTakenDue": "الوجبة المتناولة/المستحقة",
    "restTakenDue": "الراحة المأخوذة/المستحقة",
    "workingHours": "ساعات العمل",
    "breakHours": "ساعات الراحة",
    "loadedMilesRate": "معدل الأميال المحملة",
    "deadMilesRate": "معدل الأميال الفارغة",
    "account": "الحساب",
    "amount": "المبلغ",
    "approxDo": "~التوصيل",
    "approxPu": "~الاستلام",
    "approxTimeLabel": "الوقت التقريبي",
    "approxPuLabel": "الاستلام التقريبي",
    "approxDoLabel": "التوصيل التقريبي",
    "currentTrip": "الرحلة الحالية",
    "appt": "الموعد",
    "arrive": "الوصول",
    "arriveDist": "مسافة الوصول",
    "availability": "التوفر",
    "breaksAck": "استراحات مؤكدة",
    "breaksDue": "استراحات مستحقة",
    "breaksTaken": "استراحات مأخوذة",
    "bucket": "الحاوية",
    "bumped": "مُزاح",
    "cads": "الأوامر",
    "cancelCharge": "رسوم الإلغاء",
    "cancelledTrips": "الرحلات الملغاة",
    "changeReason": "سبب التغيير",
    "claimAmount": "مبلغ المطالبة",
    "claimId": "معرف المطالبة",
    "claimPaymentAmount": "مبلغ دفع المطالبة",
    "company": "الشركة",
    "companyIntakeAfterThreshold": "حصة الشركة بعد الحد",
    "completedTrips": "الرحلات المكتملة",
    "components": "المكونات",
    "dateLabel": "التاريخ",
    "day": "اليوم",
    "declined": "مرفوض",
    "distDiff": "فرق المسافة",
    "distance": "المسافة",
    "distanceViolet": "مخالفة المسافة",
    "doAddress": "عنوان التوصيل",
    "driverIntakeAfterThreshold": "حصة السائق بعد الحد",
    "dropoffDiff": "فرق التوصيل",
    "duration": "المدة",
    "engaged": "متفاعل",
    "eta": "الوقت المتوقع",
    "events": "الأحداث",
    "fee": "الرسوم",
    "flatFee": "رسوم ثابتة",
    "fromTime": "من وقت",
    "group": "المجموعة",
    "ignored": "متجاهل",
    "lateReason": "سبب التأخير",
    "loadUnloadTime": "وقت التحميل/التفريغ",
    "loadedMiles": "أميال محملة",
    "maxFactor": "أقصى معامل",
    "minimumFare": "الحد الأدنى للأجرة",
    "netProfit": "صافي الربح",
    "newDist": "مسافة جديدة",
    "noOfTrips": "عدد الرحلات",
    "noShowCharge": "رسوم عدم الحضور",
    "odometerStartEnd": "عداد المسافات بداية-نهاية",
    "onboardViolet": "مخالفة على متن المركبة",
    "otherViolet": "مخالفة أخرى",
    "outgoings": "الصادرة",
    "passedFailed": "ناجح/فاشل",
    "patientName": "اسم المريض",
    "pdOrder": "ترتيب الاستلام/التوصيل",
    "perform": "التنفيذ",
    "performDist": "مسافة التنفيذ",
    "phone": "الهاتف",
    "phoneNo": "رقم الهاتف",
    "pickupDiff": "فرق الاستلام",
    "platformCharges": "رسوم المنصة:",
    "preDist": "المسافة السابقة",
    "price": "السعر",
    "puAddress": "عنوان الاستلام",
    "puDoAddress": "عنوان الاستلام - التوصيل",
    "remaining": "المتبقي",
    "restHours": "ساعات الراحة",
    "returned": "مُعاد",
    "rigHash": "رقم المركبة",
    "rigType": "نوع المركبة",
    "service": "الخدمة",
    "serviceDate": "تاريخ الخدمة",
    "sr": "م.",
    "srHash": "م#",
    "status": "الحالة",
    "timeDifference": "فرق الوقت",
    "timeStamps": "الطوابع الزمنية",
    "timeWise": "حسب الوقت",
    "tip": "إكرامية",
    "toTime": "إلى وقت",
    "toll": "رسوم الطريق",
    "totalDeadMileRate": "إجمالي معدل الأميال الفارغة",
    "totalEarning": "إجمالي الأرباح",
    "totalEarningsColon": "إجمالي الأرباح:",
    "totalLoadedMileRate": "إجمالي معدل الأميال المحملة",
    "travel": "السفر",
    "tripEarnings": "أرباح الرحلة",
    "willCallStatus": "حالة الاتصال عند الطلب",
    "adjustTrips": "تعديل الرحلات",
    "amendmentReq": "طلب تعديل",
    "assistRequired": "هل المساعدة مطلوبة؟",
    "associateTo": "ربط بـ",
    "broker": "الوسيط",
    "calculate": "احسب",
    "clientIdMemberId": "معرف العميل / معرف العضو / MA# / AHCCCS#",
    "displayName": "الاسم المعروض",
    "documentExpiry": "انتهاء المستند",
    "driverGrievanceReport": "تقرير شكاوى السائق",
    "driverSignature": "توقيع السائق",
    "generalInformation": "معلومات عامة",
    "generateReport": "إنشاء تقرير",
    "googleApproximation": "تقدير Google",
    "localApproximation": "تقدير محلي",
    "ltiReport": "تقرير LTI",
    "markConfirmed": "وضع كمؤكد",
    "markReady": "وضع كجاهز",
    "unmarkReady": "إلغاء وضع كجاهز",
    "markUnassigned": "وضع كغير معين",
    "markVoicemail": "وضع كبريد صوتي",
    "milesReport": "تقرير الأميال",
    "modifierTwo": "المعدل الثاني",
    "otherReason": "سبب آخر",
    "partialEdit": "تعديل جزئي",
    "plusAdd": "+ إضافة",
    "rating": "التقييم",
    "rawTripSummary": "ملخص الرحلة الخام",
    "receiverEmail": "البريد الإلكتروني للمستلم",
    "state": "الولاية",
    "tripsReport": "تقرير الرحلات",
    "update": "تحديث",
    "showing": "عرض",
    "entries": "إدخالات",
    "enterInPercent": "أدخل بالنسبة المئوية",
    "enterInPercentage": "أدخل بالنسبة المئوية",
    "selectCorporatePlaceholder": "-- اختر الشركة --",
    "grievance": "شكوى",
    "itemLost": "عنصر مفقود",
    "generalShift": "الوردية العامة",
    "addCorporate": "إضافة شركة",
    "addCompanies": "إضافة شركات",
    "Accidental Reports": "تقارير الحوادث",
    "Addons": "الإضافات",
    "Announcements": "الإعلانات",
    "Appointment Types": "أنواع المواعيد",
    "Billing": "الفوترة",
    "Business Reports": "تقارير الأعمال",
    "CheckList": "قائمة التحقق",
    "Dashboard": "لوحة التحكم",
    "Availability": "التوفر",
    "Dirt Road": "طريق ترابي",
    "Driver Alerts": "تنبيهات السائق",
    "Driver Expense": "مصاريف السائق",
    "Driver Score": "درجة السائق",
    "Driver Wise": "حسب السائق",
    "EDI 835": "EDI 835",
    "Earnings": "الأرباح",
    "Extras": "إضافات",
    "Fleet": "الأسطول",
    "Grievance / Item Lost": "شكوى / عنصر مفقود",
    "Helping Material": "المواد المساعدة",
    "Invoice": "الفاتورة",
    "Itineries": "المسارات",
    "Maintenance": "الصيانة",
    "Manifest": "البيان",
    "Manual": "الدليل",
    "Modifier Codes": "رموز المعدّل",
    "Nemt Pro Tips": "نصائح NEMT",
    "Operations": "العمليات",
    "Outbounding": "الصادرة",
    "Planner": "المخطط",
    "Primary Diagnosis": "التشخيص الأولي",
    "Pro Tips": "نصائح احترافية",
    "Push to Talk": "اضغط للتحدث",
    "Rates": "الأسعار",
    "Reports": "التقارير",
    "Routing": "التوجيه",
    "SMS": "الرسائل النصية",
    "Statistics": "الإحصائيات",
    "Support": "الدعم",
    "TRFs & Claims": "TRFs والمطالبات",
    "TRFs Templates": "قوالب TRFs",
    "Trips": "الرحلات",
    "Vehicle Expense": "مصاريف المركبة",
    "Vehicle Inspection": "فحص المركبة",
    "Zones": "المناطق",
    "back": "رجوع",
    "next": "التالي",
    "previous": "السابق",
    "upload": "رفع",
    "export": "تصدير",
    "import": "استيراد",
    "refresh": "تحديث",
    "edit": "تعديل",
    "view": "عرض",
    "loading": "جاري التحميل",
    "deselectAll": "إلغاء تحديد الكل",
    "more": "المزيد...",
    "clearFilters": "مسح عوامل التصفية",
    "clearFilter": "مسح عامل التصفية",
    "clearAll": "مسح الكل",
    "applyFilters": "تطبيق عوامل التصفية",
    "applyFilter": "تطبيق عامل التصفية",
    "noData": "لا توجد بيانات",
    "noResults": "لا توجد نتائج",
    "ok": "موافق",
    "filters": "عوامل التصفية",
    "Staging": "التجهيز",
    "Assigned": "معين",

    "memberInfoHeader": "معلومات العضو",
    "serviceInfoHeader": "معلومات الخدمة",
    "dateTimeHeader": "التاريخ والوقت",
    "pickupTimeLabel": "وقت الاستلام",
    "dropoffTimeLabel": "وقت التوصيل",
    "cityLabel": "المدينة",
    "stateLabel": "الولاية",
    "zipCodeLabel": "الرمز البريدي",
    "notesHeader": "ملاحظات",
    "attachmentsHeader": "المرفقات",
    "paymentStatus": "حالة السداد",
    "assistedBy": "بمساعدة:",
    "insuranceId": "معرف التأمين",
    "ipaNumber": "رقم IPA",
    "passengerName": "اسم الراكب",
    "cellPhone": "الهاتف المحمول",
    "dob": "تاريخ الميلاد",
    "clientId": "معرف العميل",
    "forDriver": "للسائق",
    "actualMiles": "الأميال الفعلية",
    "paymentMode": "طريقة الدفع",
    "deadMinutes": "دقائق فارغة",
    "tripMiles": "أميال الرحلة",
    "tripTime": "وقت الرحلة",
    "totalTripMiles": "إجمالي أميال الرحلة",
    "totalTripTime": "إجمالي وقت الرحلة",
    "totalTripMilesInclDeadMiles": "إجمالي أميال الرحلة (بما في ذلك الأميال الفارغة)",
    "totalTripTimeInclDeadMinutes": "إجمالي وقت الرحلة (بما في ذلك الدقائق الفارغة)",
    "odometerEnd": "عداد نهاية الرحلة",
    "enRoute": "في الطريق",
    "readySince": "جاهز منذ:",
    "app": "التطبيق",
    "availabilityDays": "أيام التوفر",
    "joiningDate": "تاريخ الانضمام",
    "sunday": "الأحد",
    "sun": "الأحد",
    "monday": "الإثنين",
    "mon": "الإثنين",
    "tuesday": "الثلاثاء",
    "tue": "الثلاثاء",
    "wednesday": "الأربعاء",
    "wed": "الأربعاء",
    "thursday": "الخميس",
    "thu": "الخميس",
    "friday": "الجمعة",
    "fri": "الجمعة",
    "saturday": "السبت",
    "sat": "السبت",
    "dayMon": "الإثنين",
    "dayTue": "الثلاثاء",
    "dayWed": "الأربعاء",
    "dayThu": "الخميس",
    "dayFri": "الجمعة",
    "daySat": "السبت",
    "daySun": "الأحد",
    "addressPicker": "منتقي العنوان",
    "smsConfiguration": "إعدادات الرسائل القصيرة",
    "confirmationTemplate": "قالب التأكيد",
    "default": "افتراضي",
    "boldage": "Boldage"
};
